import React from 'react'
import { FormComponent } from '../../../components/form/DynamicForm'
import { Form, Validators } from '../../../components/form/DynamicFormTs'
import { withRouter } from "react-router-dom";

class MetodoPago extends FormComponent {

  componentDidMount() {
    this.FormConfig(
      { defaultUrl: 'metodo-pago/one', saveUrl: 'metodo-pago/save', backUrl: '/Catalogo/MetodosPago' },
      new Form([
        Form.Field('text', 'metodo', 'Clave', '', [Validators.required], 4),
        Form.Field('text', 'metodo_nombre', 'Descripcion', '', [Validators.required], 8),
      ], ['Guardar'], 'Metodos de pago'), this.formData
    )
    if (this.props.match.params.id)
      this.LoadPreds()
  }

  render() {
    return (
      <div>
        <this.FormRender />
      </div>
    )
  }
}

export default withRouter(MetodoPago)
